var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2484 2.80009C7.58331 2.80009 5.25521 4.24767 4.00937 6.40377C3.76069 6.83414 3.21021 6.98144 2.77983 6.73276C2.34946 6.48408 2.20216 5.93359 2.45084 5.50322C4.00509 2.81338 6.91447 1.00009 10.2484 1.00009C15.219 1.00009 19.2484 5.02953 19.2484 10.0001C19.2484 14.9707 15.219 19.0001 10.2484 19.0001C6.91784 19.0001 4.01095 17.1905 2.45555 14.5051C2.20642 14.075 2.35314 13.5244 2.78325 13.2752C3.21337 13.0261 3.76401 13.1728 4.01314 13.6029C5.25991 15.7554 7.58599 17.2001 10.2484 17.2001C14.2249 17.2001 17.4484 13.9765 17.4484 10.0001C17.4484 6.02364 14.2249 2.80009 10.2484 2.80009Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5996 10.0001C3.5996 9.50303 4.00255 9.10009 4.4996 9.10009H13.3479C13.845 9.10009 14.2479 9.50303 14.2479 10.0001C14.2479 10.4971 13.845 10.9001 13.3479 10.9001H4.4996C4.00255 10.9001 3.5996 10.4971 3.5996 10.0001Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66148 5.3137C9.01296 4.96222 9.58281 4.96222 9.93428 5.3137L13.9843 9.3637C14.1531 9.53248 14.2479 9.7614 14.2479 10.0001C14.2479 10.2388 14.1531 10.4677 13.9843 10.6365L9.93428 14.6865C9.5828 15.038 9.01296 15.038 8.66148 14.6865C8.31001 14.335 8.31001 13.7652 8.66148 13.4137L12.0751 10.0001L8.66148 6.58649C8.31001 6.23502 8.31001 5.66517 8.66148 5.3137Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitStatus);
export default __webpack_public_path__ + "static/media/visitStatus.44fbe2164b94fbc13a61a69888d5dde4.svg";
export { ForwardRef as ReactComponent };